import countryPhoneCodes from '~/js/modules/country-phone-codes';
import { PhoneCodeToggler } from '~/js/modules/gcv/phone-code-toggler';
// react form components
import BrochureForm from '~/js/components/general/brochure/BrochureForm';

// create new array for countries and appending a new object that represents default value
const countries = [
  {
    name: 'Select a Country',
    id: '',
    regionCode: '',
    code: ''
  },
  ...window.beaches_app.page.countries
];

const ccCountries = [
  {
    name: 'Select a Country',
    id: '',
    regionCode: '',
    code: ''
  },
  ...window.beaches_app.page.countries
];

// create new array for states and appending a new object that represents default value
const states = [
  ...window.beaches_app.page.states
];

const ccStates = [
  ...window.beaches_app.page.states
];

// react form components

ReactDOM.render(
  <BrochureForm
    countries={countries}
    ccCountries={ccCountries}
    states={states}
    ccStates={ccStates} />,
  document.getElementById('brochure-form') );

// form validations
import '~/js/modules/fend';
const $submitButton = $('.form-submit-button');
const $termConfirmation = $('#acceptTerms');
const $termsLabel = $('.js-terms-label');
let termsErrors = 0;

// Form Validation
$('.request-brochure-form').fend({
  rules: {
    firstName: 'lettersOnly',
    lastName: 'lettersOnly',
    address: 'alphanumeric',
    suite: 'alphanumeric',
    zipCode: 'alphanumeric',
    ccZipCode: 'alphanumeric',
    ccStreetAddress: 'alphanumeric',
    ccAptSuite: 'alphanumeric',
    city: 'lettersOnly',
    cccity: 'lettersOnly'
  }
});

$termConfirmation.change( () => {
  if ($termConfirmation.is(':checked') === true) {
    termsErrors = 0;
    $submitButton.prop('disabled', false );
    $('#acceptTerms-error').remove();
  }
});

$submitButton.click( () => {

  if ($termConfirmation.is(':checked') !== true) {
    termsErrors++;
    termsErrors === 1 ? $termsLabel.append('<label id="acceptTerms-error" class="has-error empty-field-error">Please Check the terms and conditions.</label>') : '';

    return false;
  }

  return true;
});

$(document).ready( () => {

  const phoneTogglerOpts = {
    countryInput: '[name=country]',
    countryCodeLabel: 'span.countryCode',
    phoneCodes: countryPhoneCodes
  };

  const countryCodeHandler = new PhoneCodeToggler(phoneTogglerOpts);

  countryCodeHandler.init();

});

// subscribe SMS
const smsProp = document.querySelector(".sms");
console.dir(smsProp);
const countryInput = document.querySelector("#gcvCountryFieldId");
console.dir(countryInput)
const smsCheckBox = document.querySelector("#subscribeSms");

countryInput.addEventListener("change", function(event){ 
    if(event.target.value === "US"){
      smsProp.classList.remove("hideSms");
      smsProp.classList.add("showSms");
    }
    else if(event.target.value !== "US"){
      smsProp.classList.add("hideSms");
      smsProp.classList.remove("showSms");

      if(smsCheckBox.checked===true){
        smsCheckBox.checked = false;
      }
    }
 });
